module.exports = __webpack_public_path__ + "img/index-product-scan-blue.b04907bd.png";